import { ChatResponseOption } from '@akin-home/chat';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import styled from 'styled-components/native';
import { ChatTextItem } from '../../../ChatItem/types';

type Props = {
  item: ChatTextItem;
  index: number;
  onPressOption?(option: ChatResponseOption, index: number): void;
};

export function ChatEmotionScalePicker(props: Props) {
  const { item, index } = props;
  const {
    data: { text, options },
  } = item;

  function onPressOption(option: ChatResponseOption) {
    props.onPressOption?.(option, index);
  }

  return (
    <Container>
      {text ? (
        <TextBlockRow>
          <TextBlock>
            <Text>{item.data.text}</Text>
          </TextBlock>
        </TextBlockRow>
      ) : null}

      {options ? (
        <PickerSection>
          {options.map((option, index) => (
            <ScaleOption
              key={index}
              index={index}
              option={option}
              onPressOption={onPressOption}
            />
          ))}
        </PickerSection>
      ) : null}
    </Container>
  );
}

const Container = styled.View`
  gap: 12px;
`;

const TextBlockRow = styled.View`
  flex-direction: row;
`;

const TextBlock = styled.View`
  background-color: ${colors.grey[200]};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 16px;
`;

const PickerSection = styled.View`
  flex-direction: row;

  gap: 10px;

  align-items: center;
`;

type ScaleOptionProps = {
  index: number;
  option: ChatResponseOption;
  onPressOption(option: ChatResponseOption): void;
};

function ScaleOption(props: ScaleOptionProps) {
  const { index, option } = props;

  function onPress() {
    props.onPressOption(option);
  }

  return (
    <ScaleOptionContainer
      size={index}
      selected={option.selected}
      color={option.color}
      onPress={onPress}
    >
      <ScaleOptionInner color={option.color} selected={option.selected}>
        {option.selected ? (
          <FontAwesomeIcon icon="check" color="white" />
        ) : null}
      </ScaleOptionInner>
    </ScaleOptionContainer>
  );
}

const ScaleOptionContainer = styled.TouchableOpacity<{
  color?: string;
  size?: number;
  selected?: boolean;
}>`
  ${({ size = 0 }) => `
    height: ${50 + 10 * size}px;
    width: ${50 + 10 * size}px;
    `}

  border-radius: 1000px;

  border-width: 2px;

  overflow: hidden;

  ${({ color }) => `
    border-color: ${color ?? 'lightgrey'};
  `}
`;

const ScaleOptionInner = styled.View<{ color?: string; selected?: boolean }>`
  ${({ color }) => `
    background-color: ${color ?? 'lightgrey'};
  `}

  opacity: ${({ selected }) => (selected ? '1' : `0.5`)};
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
